module.exports = __webpack_public_path__ + "static/media/tf.eebbabd8.svg";